import React, { useContext, useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Input from 'b2b-ui-components-lib/lib/components/input';
import { stopBackgroundScrolling } from 'common/utils/app.utils';
import Loader from 'common/utils/loader-service';
import { sendQuotationAOI } from 'home/view/manage-feasibility/services';
import { AppContext } from 'App';
import { DEFAULT_TOAST_MSG, ERROR_TOAST, SUCCESS_TOAST } from 'home/view/manage-feasibility/constants';
import { emailValidaotr } from 'common/utils/validator';
import './customModalEmail.scss';

function CustomModalEmail(props: any) {
  let { kdmInfo, order, customPopupTitle = 'Send Quotation ', closeCustomPopup, onLoad, isLoading = false, orderAuthToken, updatedEmail } = props;

  const { toast, setToast } = useContext<any>(AppContext);

  const [disableBtn, setDisableBtn] = useState(false);
  const [sendEmailTo, setSendEmailTo] = useState(updatedEmail);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  const errorMsg = ['Please Enter Valid Value'];

  const closeCustomModal = () => {
    stopBackgroundScrolling(false);
    closeCustomPopup();
  };

  const emailValidator = (value: any) => /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[\w-]+(\.[\w-]+)*(\.[\w-]{2,})$/.test(value);

  const submitCustomModal = async () => {
    Loader(true);
    stopBackgroundScrolling(false);
    try {
      const request = { email: [sendEmailTo] };
      const { res, err } = await sendQuotationAOI(request, orderAuthToken);
      if (res) {
        const message = res?.data?.result;
        setToast(true, `Quote sent successfully to email: ${sendEmailTo}`, SUCCESS_TOAST);
        scrollTo(0, 0);
        closeCustomModal();
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const isProceedDisabled = () => {
    return disableBtn;
  };

  const emailValidation = (value: any) => {
    emailValidaotr(value);
    if (emailValidaotr(value)) {
      setDisableBtn(false);
    } else {
      setDisableBtn(false);
    }
  };

  const onEmailChange = (value: any) => {
    // ;
    // value.preventDefault();
    if (!emailValidator(value)) {
      setShowErrorMsg(true);
      setDisableBtn(true);
    } else {
      setShowErrorMsg(false);
      setDisableBtn(false);
    }
    setSendEmailTo(value);
  };

  return (
    <React.Fragment>
      <div className="modal-custom open">
        <div className="modal_dialog contract_modal" style={{ maxWidth: '35%' }}>
          <div className="modal_content" style={{ padding: '0 15px' }}>
            <div className="modal_header">
              <h5>{customPopupTitle ? customPopupTitle : 'Proceed to Booking Summary'}</h5>
            </div>
            <div
              className="modal_body"
              style={{
                paddingTop: '20px',
                flexDirection: 'row',
                flexWrap: 'wrap',
                paddingLeft: '20px',
                color: '#d4000'
              }}
            >
              <div
                className="input-field"
                style={{
                  width: '95%',
                  zIndex: '1000 !important;'
                }}
              >
                <Input
                  className="input-email"
                  name="button"
                  //   type="text"
                  value={sendEmailTo}
                  //   defaultValue={updatedEmail}
                  label="Email"
                  onChange={(value: any) => onEmailChange(value)}
                  helpTexts={showErrorMsg && errorMsg}
                  required
                  // placeholder="This is a placeholder"
                  // helpTexts={["This is a help text"]}
                  //   isValidChange={emailValidation}
                />
                {/* {showErrorMsg && (
                  <p
                    style={{
                      marginTop: '-18px',
                      color: 'red'
                    }}
                  >
                    * Please enter valid email
                  </p>
                )} */}
              </div>
              <div className="next_step" style={{ justifyContent: 'flex-end', marginTop: '0px' }}>
                <Button disabled={isLoading} variant="outlinebtn" onClick={closeCustomModal}>
                  Cancel
                </Button>
                <Button variant="activebtn" onClick={submitCustomModal} disabled={isProceedDisabled() || isLoading}>
                  Send
                  {isLoading && <span className="loading_icon"></span>}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CustomModalEmail;
